import { Component, ViewChild, ElementRef, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { InformationSource } from 'src/app/domain/ot-event';

@Component({
  selector: 'app-information-source-selector',
  templateUrl: './information-source-selector.component.html',
  styleUrls: ['./information-source-selector.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InformationSourceSelectorComponent),
    multi: true
  }]
})
export class InformationSourceSelectorComponent implements ControlValueAccessor {

  @Input()
  informationSources: InformationSource[];

  val: string; // this is the updated value that the class accesses
  set value(val: string) {  // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
    this.val = val;
    this.onChange(val);
    this.onTouch(val);
  }
  get value(): string {
    return this.val;
  }

  informationSourceId: number;

  isDisabled = false;

  @ViewChild('informationSourceCustomText')
  public informationSourceCustomText: ElementRef;

  constructor() { }

  onChange: any = () => { };
  onTouch: any = () => { };

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public informationSourceChanged(): void {
    if (!this.informationSourceId) {
      this.value = null;
    } else if (this.informationSourceId === -1) {
      this.value = '';
      setTimeout(() => this.informationSourceCustomText.nativeElement.focus());
    } else if (this.informationSourceId > 0) {
      const informationSource = this.informationSources
        .find(source => source.id === this.informationSourceId);
      this.value = informationSource ? informationSource.name : '';
    }
  }
}
